import { LanguageSelector } from 'ui/components';

export const LanguageSelectorFeature: React.FC<Content.ExternalLanguagePicker> = ({ content }) => {
	return <LanguageSelector {...content.properties} />;
};
